import React, { useState } from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import { MDX } from 'contentbricks'
import { CategoryInterface } from 'types/CategoryInterface'
import { QuestionInterface } from 'types/QuestionInterface'
import { MiniVoting } from '../miniVoting'
import { Link, Tracking } from 'contentbricks'
import Scrollchor from 'react-scrollchor'
import { ShareButtons } from '@ta-interaktiv/react-share-buttons'
const RELATED_ARTICLES = require('../main/relatedArticles.yml')
const deb = false

export const DesktopVersion = ({
  categories,
  questions,
  articleID
}: {
  questions: QuestionInterface[]
  categories: CategoryInterface[]
  articleID: string
}) => {
  return (
    <div className='ui container ' id='contentGrid'>
      {categories.map((category, i) => {
        const entries = questions.filter(q => {
          if (q.category === category.cat) return q
        })
        return (
          <CategoryGroup
            key={i}
            articleID={articleID}
            category={category}
            entries={entries.sort((a, b) => {
              return +a.questionOrder - +b.questionOrder
            })}
            backLink={i > 0}
          />
        )
      })}
    </div>
  )
}

const CategoryGroup = ({
  category,
  entries,
  backLink,
  articleID
}: {
  entries: QuestionInterface[]
  category: CategoryInterface
  backLink: boolean
  articleID: string
}) => {
  return (
    <>
      <Tracking label={'contentCat:' + category.name} />

      <div className={'bgHolder ' + category.cl} id={category.cat}>
        <div className={'categoryDiv ' + category.cl}>
          <div className='imageHolder'>
            <img src={'images/trenner_' + category.cat + '.png'} />
          </div>
          <div
            className={'textHolder ' + category.textCl}
            style={category.deskPos}
          >
            {backLink && (
              <Scrollchor
                to='#navi'
                animate={{ offset: -100, duration: 500 }}
                className='backToNavi'
              >
                <i className='angle double up icon' />
                Zurück zur Übersicht
              </Scrollchor>
            )}
            <h2> {category.name}</h2>
          </div>
        </div>
        {/* <div className={'ui segment shareHolder' + category.cl}>
          <div className='ui container '>
            <ShareButtons
              // inverted={category.cl === 'sky' ? true : false}
              articleId={articleID}
            />
          </div>
        </div> */}
        <div className={'ui relaxed grid ' + category.cl}>
          <div className={'ui row ' + category.cl}>
            {entries.map((question, i) => {
              return (
                <Question
                  key={i}
                  articleID={articleID}
                  number={+question.fileId.replace('q', '')}
                  question={question.question || ''}
                  answer={question.fileId || ''}
                  icon={question.icon}
                  fileId={question.fileId}
                  iconready={question.iconready}
                  iconPos={question.iconDesktopPos}
                  type={question.desktopType}
                  bgType={category.cl}
                  cat={category.cat}
                />
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
const requireIfReady = (ready: string, fileId: string) => {
  if (ready === 'yes') {
    return require('../../images/icon_' + fileId + '.png')
  }
  return require('../../images/placeholder.png')
}
interface QuestionElement {
  number: number
  question: string
  answer: string
  icon: string
  fileId: string
  iconready: string
  iconPos: string
  type: string
  articleID: string
  cat: string
}
const Question = ({
  number,
  question,
  answer,
  icon,
  fileId,
  iconready,
  iconPos,
  type,
  articleID,
  cat
}: QuestionElement) => {
  return (
    <>
      <a id={fileId} />
      {type === 'wide' && (
        <div className='three wide computer sixteen wide tablet column'></div>
      )}
      <div
        className={
          type === 'narrow'
            ? ' eight wide computer sixteen wide tablet column'
            : ' ten wide computer sixteen wide tablet column'
        }
      >
        <div className={number === 14 ? 'question nocounter' : 'question'}>
          <h4>
            {deb ? number + ' - ' : ''}
            <br />
            {question}
          </h4>
        </div>
        {icon === 'yes' && (
          <img
            className={'ui small ' + iconPos + ' floated image'}
            src={requireIfReady(iconready, fileId)}
          />
        )}
        <div className='answer'>
          <MDX file={require('../_text/' + answer + '.mdx')} />
          <MiniVoting
            articleID={articleID}
            elementId={fileId}
            subject={'Fragen zum Schlaf | Feedback zu: ' + question}
            scrollUpTarget={cat}
            scrollUpUpTarget={'navi'}
          />
          {RELATED_ARTICLES['q' + number] ? (
            <RELATED data={RELATED_ARTICLES['q' + number]} />
          ) : (
            <div></div>
          )}
        </div>{' '}
      </div>

      {type === 'wide' && (
        <div className='three wide computer sixteen wide tablet column'></div>
      )}
    </>
  )
}

const RELATED = ({ data }) => {
  return (
    <div className='relatedArticles'>
      <small>Artikel zum Thema:</small>
      <br />

      {data.map((d, i) => {
        return (
          <div key={i}>
            <Link
              href={d[1].toString().replace('#mandant#', window.mandant)}
              icon='caret right'
              className='cbLink'
            >
              {d[0]}
            </Link>
            <br />
          </div>
        )
      })}
    </div>
  )
}
